import { Grid, Stack, TextField } from "@mui/material"
import { useState } from "react"
import { useIsMobileHandler } from "../../../../hooks/useIsMobileHandler"
import useGiftCreditActiveRequests from "../hooks/useGiftCreditActiveRequests"
import CardSkeleton from "./CardSkeleton"
import GiftCreditCard from "./GiftCreditCard"
import NotFound from "./NotFound"

const ActiveRequestsList = () => {
  const isMobile = useIsMobileHandler()
  const { data, isPending } = useGiftCreditActiveRequests()
  const [searchTerm, setSearchTerm] = useState("")
  const filteredData =
    data?.value?.filter(card => card.creditLayerName.toLowerCase().includes(searchTerm.toLowerCase())) || []

  return (
    <Stack p={1} spacing={isMobile ? 0 : 1}>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12}>
          <TextField
            variant='outlined'
            placeholder='جستجو در اعتبار من ...'
            size='small'
            fullWidth
            sx={{ flex: 1, my: 1 }}
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
          />
        </Grid>
      </Grid>

      {isPending && (
        <Grid container spacing={1}>
          {[...Array(2)].map((_, index) => (
            <Grid item xs={12} sm={6} key={index}>
              <CardSkeleton />
            </Grid>
          ))}
        </Grid>
      )}

      {!isPending && filteredData?.length > 0 && (
        <Grid container spacing={1}>
          {filteredData.map(card => (
            <Grid item xs={12} sm={6} key={card.giftCreditRequestGuid}>
              <GiftCreditCard card={card} />
            </Grid>
          ))}
        </Grid>
      )}

      {!isPending && filteredData?.length === 0 && <NotFound />}
    </Stack>
  )
}

export default ActiveRequestsList
